import { useContext } from 'react';
import { ViewInvoiceContext } from 'src/sections/view_invoices/ViewInvoiceContext';

const useViewInvoices = () => {
  const context = useContext(ViewInvoiceContext);
  if (!context) throw new Error('View Invoices context must be used inside ViewInvoicesProvider');
  return context;
};

export default useViewInvoices;
